export default {
    en: {
        messages: {
            yes: 'Yes',
            electronicSignatures: 'Electronic Signatures',
            timeAtEmployer: 'Time at Employer',
            previous: 'Previous',
            current: 'Current',
            ssn: 'Social Security Number',
            college: 'College',
            employer: 'Employer',
            currentEmployer: 'Current Employer',
            workTitle: 'Work Title',
            salaryWagesIncome: 'Salary/Wages/Income',
            submit: 'Submit',
            otherIncomeMonthly: 'Other Income (Monthly)',
            addCoBuyer: 'Would you like to add a co-buyer?',
            enterName: 'Enter Company name',
            signAndAgree: 'Agree and Sign',
            agreeToTerms: 'Agree to Terms',
            contactName: 'Contact Name',
            enterContactName: 'Enter Contact Name',
            enterContactPhone: 'Enter Contact Phone',
            contactPhone: 'Contact Phone',
            contactSoon: 'We will contact you soon.',
            stillNeedMoreInfo: 'We still need some more information to complete your pre-qualification.  Give us a call at your earliest convenience',
            termsBlurbFullApp: `By clicking the I Agree checkbox and Submit,
              I consent to have my credit file accessed for purposes of qualifying for a vehicle loan.
              This is a hard inquiry and will impact my credit score. I agree to the Privacy Policy,
              Terms and Conditions and I acknowledge I may be contacted by the dealership. I understand that
              I might not qualify depending on the qualification criteria.`,
            termsBlurb: 'By clicking the I Agree checkbox and Submit, I consent to have my credit file accessed for purposes of prequalifying for a vehicle loan. This is a soft inquiry and will not impact my credit score. I agree to the Privacy Policy, Terms and Conditions and I acknowledge I may be contacted by 700Credit. I understand that I might not prequalify depending on the prequalification criteria.',
            termsOfUse: 'Terms of Use',
            applicationComplete: 'Application Complete',
            privacyPolicy: 'Privacy Policy',
            moreInfo: 'we need your social security number to complete your pre-approval, please enter it below',
            offerExpires: 'Offer Expires',
            print: 'Print',
            viewReport: 'View Report',
            viewCertificate: 'View Certificate',
            preApprovalCertificate: 'Pre-Approval Certificate',
            moreInfoNeeded: 'More Information Needed',
            address: 'Street Address',
            enterAddress: 'Enter your street address',
            quickQualify: 'Quick Qualify',
            securedBy: 'Secured by',
            securityInformation: 'Security Information',
            beginCreditApplication: 'Begin Credit Application',
            enterSsnLast4: 'Enter the last 4 digits of your Social Security Number',
            ssnLast4: 'Last 4 digits of Social Security Number',
            enterPinCode: 'Enter your pin code',
            pinCode: 'Pin Code',
            continue: 'Continue',
            applicantInformation: 'Applicant Information',
            coApplicantInformation: 'Co-Applicant Information',
            coApplicantSecurityInformation: 'Co-Applicant Security Information',
            coApplicantEmploymentInformation: 'Co-Applicant Employment Information',
            firstName: 'First Name',
            middleName: 'Middle Name',
            lastName: 'Last Name',
            enterFirstName: 'Enter your first name',
            enterLastName: 'Enter your last name',
            phoneNumber: 'Phone Number',
            enterPhoneNumber: 'Enter your phone number',
            mustBeValidPhone: 'Must be a valid phone number.',
            enterEmail: 'Enter your email',
            permanentAddress: 'Permanent Address',
            city: 'City',
            enterCity: 'Enter your city',
            state: 'State',
            selectState: 'Select State',
            postalCode: 'Postal Code',
            priorAddress: 'Prior Address',
            weNeedYears: 'We need {num} years history',
            doYouRentOwn: 'Do you rent or own your residence?',
            rentMortgageMonthlyAmount: 'Rent/Mortgage Monthly Amount',
            timeAtResidence: 'Time at Residence',
            enterHousingPayment: 'Enter your housing payment',
            selectYears: 'Select Years',
            selectMonths: 'Select Months',
            socialSecurityNumber: 'Social Security Number',
            dateOfBirth: 'Date of Birth',
            maritalStatus: 'Marital Status',
            employmentInformation: 'Employment Information',
            employmentStatus: 'Employment Status',
            pleaseSelect: 'Please Select',
            married: 'Married',
            unmarried: 'Unmarried',
            separated: 'Separated',
            employed: 'Employed',
            unemployed: 'Unemployed',
            retired: 'Retired',
            activeMilitary: 'Active Military',
            retiredMilitary: 'Retired Military',
            other: 'Other',
            selfEmployed: 'Self-Employed',
            student: 'Student',
            select: 'Select',
            preSelectedCertificate: 'Pre-Approval Certificate',
            thisCertPresentedTo: 'This Certificate is presented to',
            congratulations: 'Congratulations',
            your: 'Your',
            scoreRangeIs: 'score range is',
            preApprovedFi: 'You have been Pre Approved for Financing',
            validOnlyAt: 'Valid Only At',
            otherIncomeAmout: 'Other income amount',
            salaryAmount: 'Salary amount',
        },
    },
    es: {
        messages: {
            yes: 'Sí',
            electronicSignatures: 'Firmas electrónicas',
            timeAtEmployer: 'Tiempo en el empleador',
            previous: 'Anterior',
            current: 'Corriente',
            ssn: 'Número de seguridad social',
            college: 'Universidad',
            employer: 'Empleadora',
            currentEmployer: 'Patrón actual',
            workTitle: 'Título de trabajo',
            salaryWagesIncome: 'Salario/Salarios/Ingresos',
            submit: 'Enviar',
            otherIncomeMonthly: 'Otros ingresos (mensuales)',
            addCoBuyer: '¿Te gustaría añadir un co-solicitante?',
            enterName: 'Nombre de empresa',
            signAndAgree: 'Aceptar y firmar',
            agreeToTerms: 'Aceptar los términos o el servicio',
            contactName: 'Nombre del contacto',
            enterContactName: 'Ingrese el nombre del contacto',
            enterContactPhone: 'Ingrese el teléfono de contacto',
            contactPhone: 'Teléfono de Contacto',
            contactSoon: 'Nos pondremos en contacto con usted pronto.',
            stillNeedMoreInfo: 'Todavía necesitamos más información para completar su precalificación. Llámenos lo antes posible',
            termsBlurbFullApp: `Al hacer clic en la casilla Acepto y enviar, doy mi consentimiento para que se acceda a mi archivo de crédito con el fin de calificar para un préstamo de vehículo. Esta es una pregunta difícil y afectará mi puntaje de crédito. Estoy de acuerdo con la Política de Privacidad, los Términos y Condiciones y reconozco que el concesionario me puede contactar. Entiendo que podría no calificar según los criterios de calificación.`,
            termsBlurb: 'Al hacer clic en la casilla de verificación Acepto y enviar, doy mi consentimiento para que se acceda a mi archivo de crédito con el fin de precalificar un préstamo vehicular. Esta es una consulta suave y no afectará mi puntaje de crédito. Estoy de acuerdo con la Política de Privacidad, los Términos y Condiciones y reconozco que 700Credit me puede contactar. Entiendo que podría no precalificar según los criterios de precalificación.',
            termsOfUse: 'Términos de Uso',
            applicationComplete: 'Solicitud Completa',
            privacyPolicy: 'Política de Privacidad',
            moreInfo: 'necesitamos su número de seguro social para completar su aprobación previa, ingrese a continuación',
            offerExpires: 'Oferta Expira',
            print: 'Impresión',
            viewReport: 'Ver Informe',
            viewCertificate: 'Ver Certificado',
            preApprovalCertificate: 'Certificado de pre-aprobación',
            address: 'Dirección',
            moreInfoNeeded: 'Se necesita más información',
            enterAddress: 'Ingrese su dirección',
            quickQualify: 'Rápido Calificar',
            securedBy: 'Asegurado por',
            securityInformation: 'Informacion de seguridad',
            beginCreditApplication: 'Comenzar la solicitud de crédito',
            enterSsnLast4: 'Ingrese los últimos 4 dígitos de su Número de Seguro Social',
            ssnLast4: 'Últimos 4 dígitos del Número de Seguridad Social',
            enterPinCode: 'Ingrese su código pin',
            pinCode: 'Código Pin',
            continue: 'Continuar',
            applicantInformation: 'Información del aplicante',
            coApplicantInformation: 'Información del co-solicitante',
            coApplicantSecurityInformation: 'Información de seguridad del co-solicitante',
            coApplicantEmploymentInformation: 'Co-solicitante de información de empleo',
            firstName: 'Nombre primero',
            middleName: 'Segundo nombre',
            lastName: 'Apellido',
            enterLastName: 'Ponga su primer nombre',
            enterFirstName: 'Ingresa tu apellido',
            phoneNumber: 'Número telefónico',
            enterPhoneNumber: 'Ingrese su número telefónico',
            mustBeValidPhone: 'Debe ser un número de teléfono válido',
            enterEmail: 'Ingresa correo electrónico',
            permanentAddress: 'Dirección permanente',
            city: 'Ciudad',
            enterCity: 'Ingrese su ciudad',
            state: 'Estado',
            selectState: 'Seleccione estado',
            postalCode: 'Código postal',
            priorAddress: 'Dirección anterior',
            weNeedYears: 'Necesitamos {num} años de historia',
            doYouRentOwn: '¿Usted alquila o es dueño de su residencia?',
            rentMortgageMonthlyAmount: 'Monto mensual de alquiler / hipoteca',
            timeAtResidence: 'Tiempo en la residencia',
            enterHousingPayment: 'Ingrese su pago de vivienda',
            selectYears: 'Seleccione años',
            selectMonths: 'Seleccione los meses',
            socialSecurityNumber: 'Número de seguridad social',
            dateOfBirth: 'Fecha de nacimiento',
            maritalStatus: 'Estado civil',
            employmentInformation: 'Informacion de Empleo',
            employmentStatus: 'Estado de Empleo',
            pleaseSelect: 'Por favor seleccione',
            married: 'Casada',
            unmarried: 'Soltera',
            separated: 'Apartada',
            employed: 'Empleado',
            unemployed: 'Desempleadas',
            retired: 'Retirado',
            activeMilitary: 'Militar Activo',
            retitedMilitary: 'Militar Retirado',
            other: 'Otra',
            selfEmployed: 'Trabajador Independiente',
            student: 'Estudiante',
            select: 'Seleccione',
            preSelectedCertificate: 'Certificado Preseleccionado',
            thisCertPresentedTo: 'Este certificado se presenta a ',
            congratulations: 'Felicidades',
            your: 'Su',
            scoreRangeIs: 'rango de puntaje de crédito es',
            preApprovedFi: 'Usted ha sido aprobado previamente para la financiación',
            validOnlyAt: 'Válido sólo en',
            otherIncomeAmout: 'Otra cantidad de ingresos',
            salaryAmount: 'Cantidad de salario',
        },
    },
};
